module.exports = __webpack_public_path__ + "img/illustration-woman-waving-hand.e1ee3cf2.svg";